import React from 'react';
import { IconPencil, IconChevronRight } from '@tabler/icons-react';

// Collapsible "Customise legend" section extracted from CreatePage's `legend-section`:
// the map-title field, unit toggle, and live legend preview. Controlled by the parent.
function LegendSection({
  title = 'Customise legend',
  mapTitleLabel = 'Map title',
  unitsLabel = 'Units',
  placeholder = '',
  customTitle = '',
  onChangeTitle,
  distanceUnit = 'metric',
  onChangeUnit,
  isExpanded = false,
  onToggleExpanded,
  legendPreview = null,
}) {
  return (
    <div className="legend-section">
      <div
        className={`legend-collapse-header ${isExpanded ? 'expanded' : ''}`}
        onClick={() => onToggleExpanded?.(!isExpanded)}
      >
        <div className="legend-collapse-title">
          <IconPencil size={18} />
          <span>{title}</span>
        </div>
        <IconChevronRight
          size={18}
          className={`legend-collapse-arrow ${isExpanded ? 'rotated' : ''}`}
        />
      </div>
      {isExpanded && (
        <div className="legend-options">
          {/* Custom Title Input */}
          <div className="legend-field">
            <label className="legend-label">{mapTitleLabel}</label>
            <input
              type="text"
              className="legend-input"
              placeholder={placeholder}
              value={customTitle}
              onChange={(e) => onChangeTitle?.(e.target.value)}
              maxLength={60}
            />
          </div>

          {/* Distance Unit Toggle */}
          <div className="legend-field">
            <label className="legend-label">{unitsLabel}</label>
            <div className="unit-toggle">
              <button
                className={`unit-option ${distanceUnit === 'metric' ? 'selected' : ''}`}
                onClick={() => onChangeUnit?.('metric')}
              >
                km
              </button>
              <button
                className={`unit-option ${distanceUnit === 'imperial' ? 'selected' : ''}`}
                onClick={() => onChangeUnit?.('imperial')}
              >
                mi
              </button>
            </div>
          </div>

          {/* Live Legend Preview */}
          {legendPreview && (
            <div className="legend-preview">
              <div className="legend-preview-line legend-preview-type">
                Title: {legendPreview.title}
              </div>
              <div className="legend-preview-line">
                Distance: {legendPreview.distance}{legendPreview.distanceUnit}
              </div>
              <div className="legend-preview-line">
                Time: {legendPreview.duration}
              </div>
              {legendPreview.powerOrPace && legendPreview.powerOrPace.type === 'power' && (
                <div className="legend-preview-line">
                  Power: {legendPreview.powerOrPace.value}{legendPreview.powerOrPace.unit}
                </div>
              )}
              {legendPreview.powerOrPace && legendPreview.powerOrPace.type === 'pace' && (
                <div className="legend-preview-line">
                  Pace: {legendPreview.powerOrPace.value} {legendPreview.powerOrPace.unit}
                </div>
              )}
              {legendPreview.elevation && (
                <div className="legend-preview-line">
                  Elevation: {legendPreview.elevation}{legendPreview.elevationUnit}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default LegendSection;
